import { render, staticRenderFns } from "./comparison_reports_component.vue?vue&type=template&id=f8a1a7c8&scoped=true&"
import script from "../assets/js/comparison_reports_component.js?vue&type=script&lang=js&"
export * from "../assets/js/comparison_reports_component.js?vue&type=script&lang=js&"
import style0 from "./comparison_reports_component.vue?vue&type=style&index=0&id=f8a1a7c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a1a7c8",
  null
  
)

export default component.exports